import { Heart } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HeartIcon = createLucideIcon(Heart);
